import ga from './ga'

const reportPageView = () => {
  if (typeof document === 'undefined') {
    return
  }

  ga('send', {
    hitType: 'pageview'
  })
}

const reportExperiment = (experimentId, variantName) => {
  ga('set', 'expId', experimentId)
  ga('set', 'expVar', variantName)
  ga('send', {
    hitType: 'event',
    eventCategory: 'experiment',
    eventAction: 'view',
    eventLabel: experimentId,
    eventValue: variantName,
    nonInteraction: true
  })
}

export { reportPageView, reportExperiment }



// WEBPACK FOOTER //
// ./common/utils/analytics.js